__webpack_require__.p = "/assets/turbo/47c1291e/ottonl/_next/";